import React from "react";
import { Button, Tooltip } from "@mantine/core";
import { appStore } from "@/app/store/appStore";
import { getRedirect, openLink, rememberLocationForPostOauth } from "@shared/utils/helpers";
import { IconBrandSteam } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { persistStore } from "@entities/StepFolder/store/persistStore";

export const initiateSteamLogin = () => {
	const realm = window.location.origin;
	const returnTo = getRedirect("steam");
	rememberLocationForPostOauth();
	const authUrl = `https://steamcommunity.com/openid/login?openid.ns=http://specs.openid.net/auth/2.0&openid.mode=checkid_setup&openid.return_to=${returnTo}&openid.realm=${realm}&openid.identity=http://specs.openid.net/auth/2.0/identifier_select&openid.claimed_id=http://specs.openid.net/auth/2.0/identifier_select`;
	openLink(authUrl);
};
const SteamOpenIDButton: React.FC = () => {
	const { t } = useTranslation();
	const isPrivacy = persistStore(state => state.isPrivacy);

	const steamLoginEnabled = appStore
		.getState()
		.gameConfig.PublicWebClientConfig.Auth?.AllowedAuthProviders.includes("steam");



	return (
		steamLoginEnabled && (
			<Button disabled={!isPrivacy} variant={"box"} onClick={initiateSteamLogin}>
				<Tooltip label={t("common.LoginWithSteam", "Login with Steam")}>
					<IconBrandSteam />
				</Tooltip>
			</Button>
		)
	);
};

export default SteamOpenIDButton;
